import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import type { DoodOpenCheck } from '@core/models/check.model';
import { CHECK_DETAILS_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { CheckDetailsBlockScenarioContent } from '@front-platform/content-builder';

import {
  CHECK_DETAILS_BLOCK_LOADING_VM,
  CheckDetailsBlockDataSource,
  CheckDetailsBlockViewModel,
} from './check-details-block-view-model';

@Injectable()
export class CheckDetailsBlockPreviewDataSource implements CheckDetailsBlockDataSource {
  readonly vm$: Observable<CheckDetailsBlockViewModel> = previewScenarioForBloc$(
    CHECK_DETAILS_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return CHECK_DETAILS_BLOCK_LOADING_VM;
      }

      const checkDetails = previewScenarioData<CheckDetailsBlockScenarioContent>(
        scenario,
        CHECK_DETAILS_BLOCK_COMPONENT,
      );
      return checkDetails
        ? ({ check: checkDetails.check as DoodOpenCheck | null } as CheckDetailsBlockViewModel)
        : CHECK_DETAILS_BLOCK_LOADING_VM;
    }),
  );
}
